import {
  ETAT_BROUILLON,
  ETAT_COMMANDE_PARTIELLEMENT,
  ETAT_ENREGISTRE,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  TYPE_COMMANDE,
  TYPE_DEVIS,
} from '@/configuration/devisConf';
import {
  BLOQUE,
  EN_ATTENTE_RELANCE_OPTION,
  OPTION,
  RELANCE_OPTION,
} from '@/configuration/optionBlocage/optionBlocage';

function getNumberFace(listAffectation) {
  if (listAffectation.length === 0) return 0;
  return listAffectation
    .map((listAffectation => listAffectation.nbFaces))
    .reduce((nbFacesTotal, nbFaces) => nbFacesTotal + nbFaces);
}

function getNumberFaceByType(affectations, referenceType, referenceEtat, etatObtenu, rang) {
  const affectionFiltered = affectations.filter((affectation) => {
    return affectation.typeReference === referenceType
      && affectation.etatReference === referenceEtat
      && affectation.etatObtenu === etatObtenu && affectation.rangOption === rang;
  });
  return getNumberFace(affectionFiltered);
}

export default function getNbFacesByEtatObtenu(affectations) {
  const nbFaceCommande = getNumberFaceByType(
    affectations, TYPE_COMMANDE, ETAT_ENREGISTRE, BLOQUE, null,
  );

  let nbFaceDevis = getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_ENREGISTRE, BLOQUE, null,
  );

  nbFaceDevis += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, BLOQUE, null,
  );

  nbFaceDevis += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_BROUILLON, BLOQUE, null,
  );

  let nbFaceBloqueOption = getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_ENREGISTRE, OPTION, 1,
  );

  nbFaceBloqueOption += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, OPTION, 1,
  );

  nbFaceBloqueOption += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_BROUILLON, OPTION, 1,
  );

  let nbFaceFacture = getNumberFaceByType(
    affectations, TYPE_COMMANDE, ETAT_FACTURE, BLOQUE, null,
  );

  nbFaceFacture += getNumberFaceByType(
    affectations, TYPE_COMMANDE, ETAT_FACTURE_PARTIELLEMENT, BLOQUE, null,
  );

  let nbFaceEnAttente = getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_ENREGISTRE, EN_ATTENTE_RELANCE_OPTION, null,
  );

  nbFaceEnAttente += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, EN_ATTENTE_RELANCE_OPTION, null,
  );

  nbFaceEnAttente += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_BROUILLON, EN_ATTENTE_RELANCE_OPTION, null,
  );

  let nbFaceRelanceOption = getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_ENREGISTRE, RELANCE_OPTION, null,
  );

  nbFaceRelanceOption += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, RELANCE_OPTION, null,
  );

  nbFaceRelanceOption += getNumberFaceByType(
    affectations, TYPE_DEVIS, ETAT_BROUILLON, RELANCE_OPTION, null,
  );

  return {
    nbFaceCommande: nbFaceCommande,
    nbFaceDevis: nbFaceDevis,
    nbFaceBloqueOption: nbFaceBloqueOption,
    nbFaceFacture: nbFaceFacture,
    nbFaceEnAttente: nbFaceEnAttente,
    nbFaceRelanceOption: nbFaceRelanceOption,
  };
}
